export const SP_BREAKPOINT = process.env.REACT_APP_SP_BREAKPOINT ?? "780px";
export const PC_BREAKPOINT = "781px";
export const PC_HEADER_HEIGHT = "115px";
export const CALENDAR_BREAKPOINT = "350px";
export const DEFAULT_DATE_VALID_TO = "9999/12/31 23:59";

export enum AppType {
  FileUpload = "file_upload",
  AccountManagement = "account_management",
}

export const APP_TYPE =
  process.env.REACT_APP_FILE_UPLOAD === "true"
    ? AppType.FileUpload
    : AppType.AccountManagement;

export const UPLOAD_FILE_TYPE = {
  excel: ["xls", "xlsx"],
  csv: ["csv"],
};

export const UPLOAD_FILE_SIZE_MB = 10;

export enum USER_ROLE {
  SYSTEM_ADMINISTRATOR = "system_administrator",
  USER = "user",
}
